module.exports = __webpack_public_path__ + "static/work36-c4f7ebd81bfb9436588187f5e6c93ad9.jpg";